import mixpanel from 'mixpanel-browser';

import { EEventsLabels } from '~/app/hocs/eventsAnalytics/eventsEnum';

import { isLocal } from '../utils/environments';

type MixpanelSessionUser = {
    globalId?: string;
    gid?: string;
    band?: string;
    zone?: string;
    roles?: string[] | Record<string, boolean> | string;
    country?: string;
    ctry?: string;
    isManager?: boolean;
    name?: string;
};

type MixpanelSession = {
    user?: MixpanelSessionUser;
} | null;

type MixpanelEvent = {
    event: EEventsLabels | string;
    session?: MixpanelSession;
    properties?: Record<string, string | number | boolean | string[]>;
};

function fireEvent({ event, properties, session }: MixpanelEvent) {
    if (!process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || isLocal()) {
        return;
    }

    try {
        const user = session?.user;

        mixpanel.track(event, {
            ...properties,
            globalId: user?.globalId ?? user?.gid,
            band: user?.band,
            zone: user?.zone,
            roles: user?.roles,
            country: user?.country ?? user?.ctry,
            isManager: user?.isManager,
            $name: user?.name,
        });
    } catch (err) {
        console.error(err);
    }
}

export const mixPanel = {
    fireEvent,
};
